import { db } from "@modules/local/db";
import { useAppLiveQuery } from "@modules/local/hooks";

export function useContentEntityInfoLiveQuery(uniqueId: string) {
  return useAppLiveQuery(() => {
    return db.uiEntities.get(uniqueId);
  }, [uniqueId]);
  // return useAppSelector(
  //   (state) => ({
  //     status: state.content.linkedData[uniqueId]?.status,
  //     moreStatus: state.content.linkedData[uniqueId]?.moreStatus,
  //     pageNumber: state.content.linkedData[uniqueId]?.pageNumber,
  //     pageSize: state.content.linkedData[uniqueId]?.pageSize,
  //     hasNextPage: state.content.linkedData[uniqueId]?.hasNextPage,
  //     totalCount: state.content.linkedData[uniqueId]?.totalCount,
  //   }),
  //   (p, n) => {
  //     if (p.status !== n.status) return false;
  //     if (p.moreStatus !== n.moreStatus) return false;
  //     if (p.pageNumber !== n.pageNumber) return false;
  //     if (p.pageSize !== n.pageSize) return false;
  //     if (p.hasNextPage !== n.hasNextPage) return false;
  //     if (p.totalCount !== n.totalCount) return false;
  //     return true;
  //   }
  // );
}
